import { Box } from "@mui/material";
import { styled } from "@mui/system";
import bg from "../../assets/images/tickets-bg.webp";

export const StyledWrapper = styled(Box)(({ theme }) => ({
  position: "relative",
  backgroundColor: theme.palette.primary.main,
  overflow: "hidden",
  "&::before": {
    content: '""',
    position: "absolute",
    inset: 0,
    backgroundImage: `url(${bg})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center top",
    mixBlendMode: "multiply",
    pointerEvents: "none",
    zIndex: 0,
  },
  "&::after": {
    content: '""',
    position: "absolute",
    inset: 0,
    background:
      "linear-gradient(180deg, rgba(235,0,40,0) 0%, rgba(235,0,40,0) 30%, rgba(235,0,40,0.6) 60%, #EB0028 100%)",
    pointerEvents: "none",
    zIndex: 1,
  },
  ".overlay": {
    display: "none",
  },
  ".footer-container": {
    position: "relative",
    zIndex: 2,
    maxWidth: theme.breakpoints.values.lg,
    margin: "0 auto",
    paddingTop: "70px",
    paddingBottom: "20px",
    paddingLeft: "24px",
    paddingRight: "24px",
    height: "100%",
  },
  ".menu-item-link": {
    textDecoration: "none",
  },
  ".menu-item-label": {
    fontFamily: "Inter",
    color: theme.palette.white.main,
    fontSize: 16,
    fontWeight: 600,
    padding: "6px 0",
    cursor: "pointer",
    lineHeight: 1.4,
    [theme.breakpoints.down("md")]: {
      fontSize: 14,
    },
  },
  ".slighter-p": {
    fontWeight: 400,
  },
  ".left-aligned-p": { textAlign: "left" },
  ".right-aligned-p": { textAlign: "right" },
  ".center-aligned-p": { textAlign: "center" },
  ".social-link": {
    width: "40px",
    height: "40px",
    cursor: "pointer",
    [theme.breakpoints.down("md")]: {
      width: "32px",
      height: "32px",
    },
  },
  ".description": {
    fontFamily: "Inter",
    fontSize: "18px",
    lineHeight: "26px",
    textAlign: "right",
    color: "#fff",
  },
  ".faq-container": {
    paddingTop: "30px",
    paddingBottom: "30px",
    [theme.breakpoints.down("md")]: {
      paddingTop: "16px",
      paddingBottom: "16px",
    },
  },
  ".copyright-box": {
    zIndex: 2,
    position: "relative",
    paddingTop: "16px",
    paddingBottom: "12px",
    "& p": {
      fontFamily: "Inter",
      fontWeight: 400,
      fontSize: "16px",
      textAlign: "center",
      color: "#fff",
      [theme.breakpoints.down("md")]: {
        fontSize: "13px",
      },
    },
  },
  ".border": {
    zIndex: 2,
    position: "relative",
    borderTop: "1px solid rgba(255,255,255,0.5)",
    maxWidth: theme.breakpoints.values.lg,
    margin: "0 auto",
  },
}));

export default StyledWrapper;
